(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    if (!window.textRevealInitialized) {
    window.textRevealInitialized = true;
    
    const initTextReveal = () => {
      const textBlocks = document.querySelectorAll('[data-text-effect="reveal"]');
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('text-visible');
          }
        });
      }, { threshold: 0.1 });
      
      textBlocks.forEach(block => observer.observe(block));
    };
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTextReveal);
    } else {
      initTextReveal();
    }
  }
  } catch(e) { console.error(e); }
})();

})();
